import React from 'react'
import getTranslation from '../functions/getTranslation'

const Translation = ({ id, trans, children, before = "", after = "" }) => {
    let transString = getTranslation(id, trans, children)

    if (before) {
        transString = before + transString
    }

    if (after) {
        transString = transString + after
    }

    return transString
}


export default Translation